module.exports = __webpack_public_path__ + "static/media/BS_F_Timeless_Sforza_Sand.c972765f.png";